/** The team: names and titles for Home and About, the home page bios, and the people in the
    structured data (src/lib/seo.ts). About adds longer introductions of its own. */

export type TeamMember = {
  name: string
  role: string
  bio: string
  /** 960 × 768 portrait, on the slice of the stripe gradient it was shot against. */
  photo: string
  /** Which slice of the stripe gradient shows while the portrait loads. */
  slice: string
  linkedin: string
}

export const team: TeamMember[] = [
  {
    name: 'Karl Paadam',
    role: 'Co-founder & CEO',
    bio: 'Built a business from scratch at PwC and grew Tax & Legal business into Estonia’s largest. Built and exited two tech companies.',
    photo: '/media/team/karl-paadam.avif',
    slice: '6%',
    linkedin: 'https://www.linkedin.com/in/karl-paadam/',
  },
  {
    name: 'Pascal Noth',
    role: 'Co-founder & COO',
    bio: 'Two decades in private equity with founder-led businesses, at Palamon Capital Partners and Partners Group.',
    photo: '/media/team/pascal-noth.avif',
    slice: '52%',
    linkedin: 'https://www.linkedin.com/in/pjnnoth/',
  },
  {
    name: 'Peter Potapov',
    role: 'Co-founder & CTO',
    bio: 'Led engineering and machine learning at Osome, including its accounting production systems, then technology at Kick.',
    photo: '/media/team/peter-potapov.avif',
    slice: '94%',
    linkedin: 'https://www.linkedin.com/in/peter-potapoff/',
  },
]
